import React, { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { Header } from './header-landing-page';

const useLandingPageLayoutStyles = createUseStyles({
    layout: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    },
    content: {
        flex: 1,
        width: '100%',
        overflowY: 'auto',
    },
});

interface LandingPageLayoutProps {
    children: ReactNode;
}

export const LandingPageLayout: FC<LandingPageLayoutProps> = ({ children }) => {
    const classes = useLandingPageLayoutStyles();

    return (
        <div className={classes.layout}>
            <Header />
            <div className={classes.content}>{children}</div>
        </div>
    );
};
